import { render } from "./TransactionByBranch.vue?vue&type=template&id=352ab78f&scoped=true"
import script from "./TransactionByBranch.vue?vue&type=script&lang=js"
export * from "./TransactionByBranch.vue?vue&type=script&lang=js"

import "./TransactionByBranch.vue?vue&type=style&index=0&id=352ab78f&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352ab78f"]])

export default __exports__